// extracted by mini-css-extract-plugin
export default {"container":"Receipts_container__1xDlU","total":"Receipts_total__1ay18","sum":"Receipts_sum__1nv-T"};